module.exports = __webpack_public_path__ + "static/media/progress_bar_0.d774a98b.svg";